import React, { useState, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import SideBar from "../components/sidebar";
import Navbar from "../components/navbar";

const AdminProtectedRoute = () => {
//   const jwt = localStorage.getItem("Admintoken");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    document.title = "";
  }, []);

  const userToken = localStorage.getItem('adminjwt');

  if (!userToken) {
    return <Navigate to="/" />;
  }

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="flex">
      <SideBar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div className="flex flex-col flex-1 ">
        <Navbar toggleSidebar={toggleSidebar} />
        <main className=" ml-64">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminProtectedRoute;